import moment from "moment"
import Cookies from 'js-cookie'

export default () => {
  return {
    reportTypes: [
      { id: 'SingleSiteNoAddress', title: 'Single Site No Address', buttonTitle: 'Single No Address' },
      { id: 'MultiSiteNoAddress', title: 'Multi Site No Address', buttonTitle: 'Multi No Address' },
      { id: 'UnknownSiteNoAddress', title: 'Unknown No Address', buttonTitle: 'Unknown No Address' },
      { id: 'ReadyToFinalize', title: 'Ready To Finalize', buttonTitle: 'Ready To Finalize' },
      { id: 'InProgress2', title: 'In Progress', buttonTitle: 'In Progress' },
      //{ id: 'WaitingThisWeek', title: 'Closed This Week Waiting Shipments', buttonTitle: 'This Week' },
      //{ id: 'WaitingOlder', title: 'Older Still Waiting Shipments', buttonTitle: 'Older' },
      //{ id: 'InProgress', title: 'In Progress', buttonTitle: 'In Progress' },
      //{ id: 'CompletedLast3Weeks', title: 'Completed Last 3 Weeks', buttonTitle: '3 Weeks' },
      //{ id: 'ByTerritory', title: 'My Accounts', buttonTitle: 'My Accounts' },
      //{ id: 'Recent', title: 'Recent Opportunities', buttonTitle: 'Recent' },
      { id: 'Flagged', title: 'Flagged', buttonTitle: 'Flagged' },
      { id: 'Completed', title: 'Completed', buttonTitle: 'Completed' },

    ],

    // IsShipRequestedComplete, IsShipTrackingComplete, IsShipDeliveryComplete
    filterOpportunitiesByReportType(opportunities, reportType) {
      const territory = Cookies.get('territory')

      return opportunities.filter(o => {
        // TODO SingleSiteNoAddress, MultiSiteNoAddress, UnknownSiteNoAddress, ReadyToFinalize, InProgress2, Completed
        if (reportType === 'WaitingThisWeek' && !(moment(o.CloseDate) > moment().subtract('1', 'week') && moment(o.CloseDate) <= moment() && !o.IsShipRequestedComplete)) return false
        if (reportType === 'WaitingOlder' && !(moment(o.CloseDate) < moment().add('1', 'week') && !o.IsShipRequestedComplete)) return false
        if (reportType === 'InProgress' && !(o.IsShipRequestedComplete && !o.IsShipDeliveryComplete)) return false
        if (reportType === 'CompletedLast3Weeks' && !(o.IsShipDeliveryComplete)) return false
        if (reportType === 'ByTerritory' && !(o.Account.Territory__c === territory)) return false
        if (reportType === 'Recent') return true
        if (reportType === 'Flagged' && !(o.Order_Flagged__c)) return false
        return true
      })
    }
  }
}